import React from 'react';
import './MainContainer.css';

const MainContainer = props => (
  <div className="MainContainer">
    <div className="content">
      {props.children}
    </div>
  </div>
);

export default MainContainer;



// WEBPACK FOOTER //
// ./src/main/components/MainContainer.js